import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import ConectUs from "../../components/ConectUs";
import { motion } from "framer-motion";
import OfferPresencial from "../../components/view/OfferPresencial";
import OfferPresencial1 from "../../components/view/OfferPresencial1";
import BlockLeftImage from "../../components/BlockLeftImage";
import ImageGallery from "../../components/ImageGallery";

import Modal from "../../components/Modal";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/6c1024f7-f270-434b-9529-da6816afe2d2" +
  "?include=field_imagen_portada.field_media_image,field_imagen3.field_media_image,field_imagen4.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_imagen3,field_imagen4,field_bloque4,field_bloque5" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function Presencial() {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const DataDisplay = ({ data }) => {
    // Verificación estricta de galería
    const hasGallery = Array.isArray(data?.galeria)
      ? data.galeria.length > 0
      : Boolean(data?.galeria);

    return (
      <div>
        <div className="mt-10">
          <img src={data.imagen_portada} alt="cabecera" />{" "}
        </div>

        {/* Sección matricula */}
        <section className="my-12 px-4 flex justify-center">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="w-full max-w-3xl bg-gradient-to-br from-[#004270] via-[#002f52] to-slate-950 rounded-2xl shadow-xl border border-[#febe10]/20 p-8 md:p-10 flex flex-col items-center text-center gap-6"
          >
            {/* Texto y Botones (Estilo 100% estático, sin condicionales) */}
            <div
              dangerouslySetInnerHTML={{ __html: data.texto_portada }}
              className="w-full flex flex-col items-center text-center  
                /* Párrafos */
                [&_p]:text-slate-200
                        
                [&_h4]:text-[#febe10]
                  [&_h4]:mt-6
                 [&_h4]:text-lg
                [&_h4_strong]:text-lg
                 [&_h4]:p-0

                /* Título Principal h2 */
               
                [&_h2]:text-white
               [&_h2]:p-0
                [&_h2_strong]:text-white

                   [&_h3]:text-white
                      [&_h3_strong]:text-white

                /* Botón de acción principal */
                [&_a]:inline-flex
                [&_a]:items-center
                [&_a]:justify-center
                [&_a]:px-7
                [&_a]:py-3.5
                [&_a]:mt-4
                [&_a]:text-sm
                [&_a]:font-bold
                [&_a]:text-slate-950
                [&_a]:bg-[#febe10]
                [&_a]:hover:bg-[#e0a60b]
                [&_a]:rounded-xl
                [&_a]:shadow-md
                [&_a]:transition-all
                [&_a]:duration-200
                [&_a]:hover:scale-105
                [&_a]:mx-auto
              "
            />

            {/* Modal / Galería: solo se monta si existen elementos */}
            {hasGallery && (
              <div className="pt-4 border-t border-white/10 w-full flex justify-center [&_button]:text-white   [&_button]:font-bold [&_button:hover]:text-[#febe10] ">
                <Modal
                  title="Proceso de matrícula"
                  content={
                    <div className="max-w-[350px] m-auto">
                      {" "}
                      <ImageGallery gallery={data.galeria} />
                    </div>
                  }
                />
              </div>
            )}
          </motion.div>
        </section>

        <section className="max-w-6xl m-auto px-6  sm:px-0 pb-10">
          <div
            className=" button-a grid grid-cols-1 sm:grid-cols-2 sm gap-6
  [&_h2]:text-xs
  [&_h2]:inline-flex
    [&_h2_strong]:text-xs
 
    [&_h2]:p-2
   
    [&_h2]:rounded-3xl
  [&_h2]:border 
  [&_h2]:border-gray-200 
  [&_h2]:bg-slate-100 
  [&_h2]:text-[#004270]  
  "
          >
            {data.bloque1 && (
              <div
                className="border  p-4 rounded-3xl "
                dangerouslySetInnerHTML={{
                  __html: data.bloque1,
                }}
              />
            )}

            {data.bloque2 && (
              <div
                className="border  p-4 rounded-3xl"
                dangerouslySetInnerHTML={{
                  __html: data.bloque2,
                }}
              />
            )}
          </div>
        </section>
        <div className="py-16 bg-slate-50">
          <div
            className="text-center"
            dangerouslySetInnerHTML={{
              __html: data.bloque4,
            }}
          />
          <OfferPresencial1></OfferPresencial1>
        </div>

        <div className="py-10">
          <div
            className="text-center"
            dangerouslySetInnerHTML={{
              __html: data.bloque5,
            }}
          />
          <OfferPresencial></OfferPresencial>
        </div>
        <div className="bg-slate-50">
          <BlockLeftImage
            src={data.imagen3}
            content={
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque3,
                  }}
                />
                <div className="mt-10">
                  <Modal
                    title="Conoce las temáticas de la prueba"
                    content={
                      <>
                        <img src={data.imagen4} alt="utpl"></img>
                      </>
                    }
                  ></Modal>{" "}
                </div>
              </>
            }
          ></BlockLeftImage>
        </div>
      </div>
    );
  };

  return (
    <>
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>

      <div className="padding2 mt-10">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes presenciales."
          facebook="https://www.facebook.com/utplpresencial/"
          instagram="https://www.instagram.com/utpl/"
          tiktok="https://www.tiktok.com/@utpl.ec"
        ></ConectUs>
      </div>
    </>
  );
}

export default Presencial;
